import React, { useState } from 'react';
import '../css/Projects.css';

const Projects = () => {
  const [scrollIndex, setScrollIndex] = useState(0);
  const totalProjects = 6;

 const handleScroll = (direction) => {
   if (direction === 'left' && scrollIndex > 0) {
     setScrollIndex(scrollIndex - 1);
   } else if (direction === 'right' && scrollIndex < totalProjects - 1) {
     setScrollIndex(scrollIndex + 1);
   }
 };
  

  const getProjectClass = (index) => {
    if (index === scrollIndex) {
      return 'project-item active'; // Élément mis en avant
    } else if (index === scrollIndex - 1 && scrollIndex > 0) {
      return 'project-item left'; // Élément à gauche
    } else if (index === scrollIndex + 1 && scrollIndex < totalProjects - 1) {
      return 'project-item right'; // Élément à droite
    } else {
      return 'project-item'; // Autres éléments
    }
  };

  return (
    <>
      <section id="projects" className="projects-section">
        <div className="vertical-line-profile"></div>
         {/* Rectangle d'information */}
         <div className="profile-info-rectangle-projects">
             <p>
             <p><strong>
                 Découvrez ci-dessous mon parcours unique
             </strong></p>
             Voici une sélection de mes projets, réalisés pour mettre en pratique mes compétences en développement et résoudre des problématiques réelles. 
             Ils illustrent mon parcours, ma créativité et mon expertise technique.
           </p>
         </div>
        <div className="projects-carousel-wrapper">
          <button className="carousel-button left" onClick={() => handleScroll('left')}>&#8249;</button>
          <div className="projects-container" style={{ transform: `translateX(-${scrollIndex * 220}px)` }}>
            {[1, 2, 3, 4, 5, 6].map((project, index) => (
              <div key={index} className={getProjectClass(index)}>
                <img src={`https://picsum.photos/200/300?random=${project}`} alt={`Project ${project}`} />
                <div className="project-info">
                  <h3>Project {project}</h3>
                  <p>Description du projet {project}...</p>
                </div>
              </div>
            ))}
          </div>
          <button className="carousel-button right" onClick={() => handleScroll('right')}>&#8250;</button>
        </div>
      </section>
      <section id="technologies" className="technologies-section">
      <div className="company-slider demo-2">
        <div className="slider-container">
          <div className="slider-content-wrapper">
            <div className="company-logos-container">
              <div><i className="devicon-c-plain"></i> {/* C Programming */}</div>
              <div><i className="devicon-cplusplus-plain"></i> {/* C++ Programming */}</div>
              <div><i className="devicon-python-plain"></i> {/* Python Programming */}</div>
              <div><i className="devicon-react-original"></i> {/* React */}</div>
              <div><i className="devicon-docker-plain"></i> {/* Docker */}</div>
              <div><i className="devicon-django-plain"></i> {/* Django */}</div>
              <div><i className="devicon-html5-plain"></i> {/* HTML */}</div>
              <div><i className="devicon-css3-plain"></i> {/* CSS */}</div>
              <div><i className="devicon-javascript-plain"></i> {/* JavaScript */}</div>
              <div><i className="devicon-markdown-original"></i> {/* Markdown */}</div>
              <div><i className="devicon-bash-plain"></i> {/* Bash */}</div>
              <div><i className="devicon-vagrant-plain"></i> {/* VirtualBox */}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    </>
  );
};

export default Projects;
